import { UserService } from './../../services/user.service';
import { Component, OnInit, OnDestroy, inject, computed } from '@angular/core';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import { ContentfulService } from '../../services/contentful.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { TourService } from 'ngx-ui-tour-md-menu';
import { EnvironmentVariablesService } from 'src/app/services/environment-variables.service';
import { ActivityTrackingService } from 'src/app/services/activity-tracking.service';
import { InvestorDropdownComponent } from '../investor-dropdown/investor-dropdown.component';
import { MatIconModule } from '@angular/material/icon';
import { GcmHeaderComponent } from '@gcm/gcm-ui-angular';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { InvestorsStorageService } from 'src/app/services/investors-storage.service';
import { HeaderResponse } from 'src/app/models/interfaces/contentful-response.interface';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-header',
    imports: [
        InvestorDropdownComponent,
        MatIconModule,
        GcmHeaderComponent,
        MatMenuModule,
        MatButtonModule,
        RouterModule
    ],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
    router = inject(Router);
    private contentfulService = inject(ContentfulService);
    userService = inject(UserService);
    tourService = inject(TourService);
    evService = inject(EnvironmentVariablesService);
    activityTracking = inject(ActivityTrackingService);
    private activatedRoute = inject(ActivatedRoute);
    private investorsStorage = inject(InvestorsStorageService);

    userEmail!: string;
    displayName!: string;
    welcomeLabelText = '';
    logoutLabelText = '';
    showInvestorsDropList = false;
    readonly selectedInvestorId = toSignal(this.investorsStorage.getActiveInvestorId(), { initialValue: undefined as unknown as number });
    displayNameInitials = '';
    queryParams!: Params;
    componentDestroyed$ = new Subject<boolean>();

    private readonly headerData = toSignal(this.contentfulService.fetchCommonAssets('header', '') as unknown as Observable<HeaderResponse | null>, { initialValue: null });
    readonly error = computed(() => this.headerData()?.error);
    readonly logoutIconUrl = computed(() => this.headerData()?.data?.header?.iconsCollection?.items[0]?.iconImage?.url ?? '');

    ngOnInit(): void {
        this.userEmail = this.userService.getUserEmail();
        this.getUserInfo();
        this.activatedRoute.queryParams.pipe(takeUntil(this.componentDestroyed$)).subscribe(params => {
            this.queryParams = {};
            if (params['reportingdate']) {
                this.queryParams['reportingdate'] = params['reportingdate'];
            }
        })
    }

    logoutClick(): void {
        this.userService.logoutApp();
    }

    getUserInfo(): void {
        this.displayName = this.userService.getUserFullName();
        this.getDisplayNameInitials();
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next(true)
        this.componentDestroyed$.complete()
    }

    getDisplayNameInitials() {
        this.displayNameInitials = this.displayName.split(/\W+/).map((name) => name[0]).join('').slice(0, 4);
    }
}

